import Vue from 'vue';
import Vuex from 'vuex';
import {router} from "./router";
// import commin from "./commin";
Vue.use(Vuex);

import axios from "axios";

const stores = new Vuex.Store({
    state: {
        admin: JSON.parse(sessionStorage.getItem("admin")) ? JSON.parse(sessionStorage.getItem("admin")) : false,
        online: JSON.parse(sessionStorage.getItem("online")) ? JSON.parse(sessionStorage.getItem("online")) : false ,
        isShowLoginBox: false,
        searchVal: sessionStorage.getItem("searchVal") ? sessionStorage.getItem("searchVal") : null,
        isRouterAlive: true,
        bookInfo: {
            cover: require("../imgs/audio/default_book_cover.png")
        },
        collectCode: null,
        historyCode: null,
        chapters: [],
        actChapter: {
            name: "云图有声"
        },
        actChapterCurrentTime: -1,
        actChapterIdx: -1,
        totalPage: -1,
        isShowDialogPage: false,
    },
    mutations: {
        setAdmin(state, boolean) {
            state.admin = boolean;
        },
        setOnline(state, val) {
            state.online = val;
        },
        setSearchVal(state, val) {
            state.searchVal = val;
        },
        setIsRouterAlive(state, val) {
            state.isRouterAlive = val;
        },
        setIsShowLoginBox(state, val) {
            state.isShowLoginBox = val;
        },
        setBookInfo(state, obj) {
            state.bookInfo = obj;
        },
        setCollectCode(state, val) {
            state.collectCode = val;
        },
        setHistoryCode(state, val) {
            state.historyCode = val;
        },
        setChapters(state, arr) {
            state.chapters = arr;
        },
        setActChapter(state, obj) {
            state.actChapter = obj;
        },
        setActChapterCurrentTime(state, val) {
            state.actChapterCurrentTime = val;
        },
        setActChapterIdx(state, val) {
            state.actChapterIdx = val;
        },
        setTotalPage(state, val) {
            state.totalPage = val;
        },
        setIsShowDialogPage(state, val) {
            state.isShowDialogPage = val;
        },
    }
})


// 路由请求拦截
// http request 拦截器
// axios.interceptors.request.use(
    // config => {
        // config.headers = {'X-Requested-With': 'XMLHttpRequest'};
        
        // if( localStorage.getItem("token" + localStorage.getItem("version")) ){
        //     config.headers.token = localStorage.getItem("token" + localStorage.getItem("version") );
        // }
        // stores.state.isLoading = true;
//         return config;
//     },
//     error => {
//         return Promise.reject(error.response);
//     }
// );
  
// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if( response.data.code == 401 ) {
            // stores.state.bookInfo = {
            //     cover: require("../imgs/audio/default_book_cover.png")
            // };
            // stores.state.collectCode = null;
            // stores.state.historyCode = null;
            // stores.state.chapters = [];
            // stores.state.actChapter = {
            //     name: "云图有声"
            // };
            // stores.state.actChapterCurrentTime = 0;
            // stores.state.actChapterIdx = -1;
            // stores.state.totalPage = -1;
            stores.state.online = false;
            sessionStorage.setItem("online", false);
            stores.state.admin = false;
            sessionStorage.setItem("admin", false);
            console.log(Vue.$router)
            // router.replace({
            //     path: "/login"
            // })
        }
        // stores.state.isLoading = false;
        return response;
    },
    error => {
        return Promise.reject(error.response) // 返回接口返回的错误信息
    }
);

export default stores;